/* eslint-disable @typescript-eslint/ban-types */
import { ApolloCache, FieldPolicy } from '@apollo/client';
import { uniq } from 'ramda';

import { Event, EventFragment, EventsResponse } from '../../graphql/generated';

/**
 * References the same `type` as defined in `typePolicies`
 * configured in src/providers/graphql.tsx
 */
const PARENT_KEY = 'CedantDetails';
const FIELD_NAME = 'events';

export const clearCachedEvents = (
  cache: ApolloCache<object>,
  cedant: string
): boolean => {
  const eviction = cache.evict({
    id: `${PARENT_KEY}:${cedant}`,
    fieldName: FIELD_NAME,
  });
  cache.gc();
  return eviction;
};

export const fileActivityEventsPagination: Record<string, FieldPolicy> = {
  [FIELD_NAME]: {
    keyArgs: false,
    merge(existing: EventsResponse, incoming: EventsResponse): EventsResponse {
      let events: EventFragment[] = [];

      if (existing?.events) {
        events = events.concat(existing.events);
      }

      if (incoming?.events) {
        events = events.concat(incoming.events);
      }

      const hasReachedEnd = existing?.hasMore === false;
      const hasMore =
        hasReachedEnd && incoming.hasMore ? false : incoming.hasMore;
      const dedupedEvents = uniq(events) as Event[];

      return {
        ...incoming,
        events: dedupedEvents,
        hasMore,
      };
    },
  },
};
